export interface IAccessKeyEntityRef {
  id: number;
  name: string;
}

export interface IAccessKeyElementModel {
  id: number;
  organizationId?: number | null;
  organization?: IAccessKeyEntityRef | null;
  campaignOrganizerId?: number | null;
  campaignOrganizer?: IAccessKeyEntityRef | null;
  campaignId?: number | null;
  campaign?: IAccessKeyEntityRef | null;
  eventId?: number | null;
  event?: IAccessKeyEntityRef | null;
  clientKey: string;
  description: string;
  createdAt: string;
  allowAllSessions: boolean;
  logActivity: boolean;
  restrictAdminRoles: boolean;
  readOnly: boolean;
  advancedPermissions: boolean;
  externalIntegrationSystem?: string | null;
  readAllowed?: number | null;
  createAllowed?: number | null;
  editAllowed?: number | null;
  deleteAllowed?: number | null;
  disabled?: boolean;
  disabledAt?: string | null;
}

export interface IAccessKeyCreatedModel {
  organizationId?: number | null;
  organization?: IAccessKeyEntityRef | null;
  campaignId?: number | null;
  campaign?: IAccessKeyEntityRef | null;
  eventId?: number | null;
  event?: IAccessKeyEntityRef | null;
  campaignOrganizerId?: number | null;
  campaignOrganizer?: IAccessKeyEntityRef | null;
  clientKey: string;
  clientSecret: string;
  description: string;
  createdAt: string;
}

export interface IAccessKeyEditModel {
  organizationId?: number | null;
  campaignOrganizerId?: number | null;
  campaignId?: number | null;
  eventId?: number | null;
  description: string;
  allowAllSessions: boolean;
  logActivity: boolean;
  restrictAdminRoles: boolean;
  readOnly: boolean;
  noSecret: boolean;
  advancedPermissions: boolean;
  externalIntegrationSystem?: string | null;
  readAllowed?: number | null;
  createAllowed?: number | null;
  editAllowed?: number | null;
  deleteAllowed?: number | null;
}

// A key can be disabled when it is live and belongs to a scope or a registration platform.
export const canDisableAccessKey = (key?: IAccessKeyElementModel | null) =>
  !!key &&
  !key.disabled &&
  !!(
    key.organizationId ||
    key.campaignOrganizerId ||
    key.eventId ||
    key.campaignId ||
    key.externalIntegrationSystem
  );

export const maskClientKey = (key: string, visibleLead: number = 8) => {
  if (!key) return '';
  if (key.length <= visibleLead) return key;
  return key.substring(0, visibleLead) + '••••';
};
